import { defineStore } from 'pinia';
import priceproducts from '../service/priceproducts';
import products from '../service/products';
import iconsService from '../service/icons';
import utils from '../service/utils';

const productStore = defineStore('product', {
  state: () => {
    return {
      products: [],
      selectedProduct: null,
      sortAscending: false,
      product: null,
      price: '',
      loading: false,
      rawData: [],
    };
  },
  actions: {
    async getNames() {
      try {
        const res = await products.getNames();
        return res.result;
      } catch (e) {
        throw e;
      }
    },
    async searchProducts(query) {
      if (query) {
        try {
          await this.getAllProducts();
          let clone = [...this.products];
          let filteredArray = clone.filter((product) => {
            return product.name.toUpperCase().includes(query.toUpperCase()) || product.type.includes(query.toUpperCase()) || null;
            // product.price.toString().includes(query.toString())
          });
          this.products = filteredArray;
        } catch (err) {
          console.log(err);
        }
      } else await this.getAllProducts();
    },
    sortProducts(key) {
      this.sortAscending = !this.sortAscending;
      let clone = [...this.products];
      if (key === 'name' || key === 'type') {
        clone.sort(utils.alphabeticSorting(key, this.sortAscending));
      } else if (key === 'price') {
        clone.sort(utils.numericalSorting(key, this.sortAscending));
      }
      this.products = clone;
    },
    async getAllProducts() {
      try {
        this.loading = false;
        const res = await products.getAllProducts();
        const databaseProducts = res.result;
        const icons = iconsService.getIcons();
        const productsArray = [];
        for (let icon of icons) {
          const product = databaseProducts.find((p) => p.name == icon.name);
          if (product) {
            product.icon = icon.icon;
            productsArray.push(product);
          }
        }
        this.products = productsArray;
        this.loading = false;
        return productsArray;
      } catch (error) {
        console.log(error);
      }
    },
    setProducts(products) {
      this.products = products;
    },

    async getProductsById(id) {
      try {
        const res = await products.getProductsById(id);
        this.selectedProduct = await res.result;
        return res.result;
      } catch (error) {
        console.log(error);
      }
    },
    async createProduct(product) {
      try {
        const productRes = await priceproducts.createPrice({
          product: product.name,
          price: product.price,
        });
        await products.createProduct({
          ...product,
          price: productRes.result._id,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async removeProduct(id) {
      try {
        const res = await products.removeProduct(id);
        this.products = this.products.filter((u) => u._id !== id);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async updateProduct(id, product, priceId) {
      try {
        const productToEdit = await this.getProductsById(id);
        if (!productToEdit.price && product.price) {
          // If product previously didn't have price, create one and edit this product with it
          const productRes = await priceproducts.createPrice({
            product: product.name,
            price: product.price,
          });
          await products.updateProduct(id, {
            ...product,
            price: productRes.result._id,
          });
        } else if (productToEdit.price) {
          // await products.updateProduct(id, product);
          const productRes = await priceproducts.updatePrice(priceId, {
            product: product.name,
            price: product.price,
          });
          await products.updateProduct(id, {
            ...product,
            price: productRes.result._id,
          });
        }
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
  },
});

export default productStore;
